<template>
  <div class="service-code-badges">
    <div v-for="badge in badges" :key="badge.fullName" v-bind:class="{'badge': true}">
      <v-layout align-center>
        <service-as-badge :service-id="badge.id"/>

        <service-quantity-info
          :requested-quantity="badge.requestedQuantity"
          :requested-quantity-in-period="badge.requestedQuantity"
          :executed-quantity="badge.executedQuantity"
          :executed-quantity-in-period="badge.executedQuantity"
        />
      </v-layout>
    </div>
    <div class="clear-both"></div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import {getContrastFontColorByBackground} from '../helpers/styles'
  import {mapGetters} from 'vuex'
  import CaseServiceLogEvent from './Sales/case/CaseServiceLogEvent'
  import ServiceAsBadge from "./Ui/mcc/ServiceAsBadge";
  import ServiceQuantityInfo from "./analytics/ServiceQuantityInfo";

  export default {
    name: 'service-code-badges',
    components: {
      CaseServiceLogEvent,
      ServiceAsBadge,
      ServiceQuantityInfo
    },
    props: {
      servicesById: {
        type: Object
      },
      caseServices: {
        type: Array
      }
    },
    computed: {
      ...mapGetters({
        availableServiceGroupsById: 'availableServiceGroupsById'
      }),
      badges() {
        // todo(egor): remove and use `case-as-badge`
        let result = []
        for (let caseService of this.caseServices) {
          let service = _.get(this.servicesById, caseService.serviceId, null)
          if (service == null) {
            continue
          }

          const colorScheme = _.get(this.availableServiceGroupsById, [service.groupId, 'colorScheme'], void 0)

          let badgeFontColor = getContrastFontColorByBackground(colorScheme)

          result.push({
            id: service.id,
            code: service.code,
            fontColor: badgeFontColor,
            backgroundColor: colorScheme,
            fullName: service.title,
            quantity: caseService.quantity,
            requestedQuantity: caseService.quantity,
            executedQuantity: caseService.executedQuantity
          })
        }

        return result
      }
    }
  }
</script>

<style scoped>
  .service-code-badges .chip--small {
    height: 22px;
  }

  .service-code-badges .chip--content {
    padding: 0 6px;
  }

  .service-code-badges ul {
    list-style-type: none;
  }

  .service-code-badges .badge {
    float: left;
  }

  .service-code-badges .clear-both {
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceCodeBadges.vue